import '@fullcalendar/react/dist/vdom';
import React from 'react';
import ReactDOM from 'react-dom';
import { RootStoreProvider } from '@uplift/providers';
import { LocalStorageService } from '@uplift/services';
import { applyGlobalStyles } from '@uplift/styles';
import { restClient } from '@uplift/api';
import { App } from './app/app';
import { environment } from './environments/environment';
import { rootStore } from './app/rootStore';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { EnvironmentProvider } from '@uplift/contexts';

applyGlobalStyles();

LocalStorageService.setAppNameSpace(environment.appNameSpace);


restClient.configure({ apiEndpoint: environment.restApi, authStore: rootStore.authStore });
const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {},
    queries: {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  }
});


ReactDOM.render(
  <React.StrictMode>
    <EnvironmentProvider environment={environment}>
      <RootStoreProvider rootStore={rootStore}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools />
          <App />
        </QueryClientProvider>
      </RootStoreProvider>
    </EnvironmentProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
